import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import {
  PullToRefresh,
  ReleaseContent,
  RefreshContent,
  PullDownContent,
} from "react-js-pull-to-refresh";
import ScrollToTop from "./ScrollToTop";
import cookie from "react-cookies";
import { useClearCache } from "react-clear-cache";
import Header from "./components/Global/Header";
import "./Styles/global/global.scss";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {withRouter} from 'react-router-dom'
import Loadable from "react-loadable";
import Loader from "./helpers/loader";
import { useSelector } from "react-redux";

// //lazy load components
const Register = Loadable({
  loader: () => import("././components/Agent/Auth/Register"),
  loading: Loader,
  delay: 100, //   0.1seconds
});

const Login = Loadable({
  loader: () => import("././components/Agent/Auth/Login"),
  loading: Loader,
  delay: 100, //   0.1seconds
});

const Onboarding = Loadable({
  loader: () => import("./components/Agent/Onboarding/Onboarding"),
  loading: Loader,
  delay: 100, //   0.1seconds
});

const ForgotPassword = Loadable({
  loader: () => import("././components/Agent/Auth/ForgotPassword"),
  loading: Loader,
  delay: 100, //   0.1seconds
});

const SecuredRoutes = Loadable({
  loader: () => import("./SecuredRoutes"),
  loading: Loader,
  delay: 100, //   0.1seconds
});

const ResetPassword = Loadable({
  loader: () => import("./components/Agent/Auth/ResetPassword"),
  loading: Loader,
  delay: 300, // 0.3 seconds
});

// Call it once in your app. At the root of your app is the best place
toast
  .configure

  //   // position: toast.POSITION.TOP_CENTER,
  //   // className: 'toasterClass'
  ();

// const isAuthenticated = false;

function ProtectedRoute({ children, ...rest }) {
  const isLoggedIn = useSelector(({ user }) => user.loggedIn);
  const user = useSelector(({ user }) => user.user.user);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn ? (
          user.bvn && user.agent_profile && user.transaction_pin ? (
            children
          ) : (
            <Redirect to="/onboarding" />
          )
        ) : (
          <Redirect to={{ to: "/login", state: { from: location } }} />
        )
      }
    />
  );
}

function ProtectedRoute2({ children, ...rest }) {
  const isLoggedIn = useSelector(({ user }) => user.loggedIn);
  const user = useSelector(({ user }) => user);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLoggedIn && user ? (
          user.user.user.agent_profile === null ||
          user.user.user.bvn === null ||
          user.user.user.transaction_pin === null ? (
            children
          ) : (
            <Redirect to="/agent/dashboard" />
          )
        ) : (
          <Redirect to={{ to: "/login", state: { from: location } }} />
        )
      }
    />
  );
}

function App() {
  const { isLatestVersion, emptyCacheStorage } = useClearCache();
  // const isLoggedIn = useSelector(({ user }) => user.loggedIn);

  useEffect(() => {
    if (!isLatestVersion) {
      emptyCacheStorage();
      cookie.split(";").forEach((c) => {
        cookie = c
          .replace(/^ +/, "")
          .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
      });
    }
  }, []);
  return (
    <>
      <Router>
        <ScrollToTop />
        <div className="App">
          <Header />

          <PullToRefresh
            pullDownContent={<PullDownContent />}
            releaseContent={<ReleaseContent />}
            refreshContent={<RefreshContent />}
            onRefresh={() => window.location.reload()}
            pullDownThreshold={70}
            backgroundColor="white"
            startInvisible={true}
          >
            <Switch>
              {/* <Route component={Login} /> */}
              <Route path="/register" component={Register} />
              <Route path="/login" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route path="/reset-password" component={ResetPassword} />
              <ProtectedRoute2 path="/onboarding">
                <Onboarding />
              </ProtectedRoute2>
              <Route exact path="/" component={Login} />

              <ProtectedRoute path="/agent">
                <SecuredRoutes />
              </ProtectedRoute>
              {/* <Redirect to='/login' /> */}
            </Switch>
          </PullToRefresh>
          {/* <Switch> */}
          {/* {isLoggedIn ? 

								(<ProtectedRoute path ="/dashboard" >
								<SecuredRoutes/>
								</ProtectedRoute>
								)	
								:
								<PublicRoutes/>
								
								} */}
          {/* <Route component = {Login}/> */}

          {/* </Switch> */}
        </div>
      </Router>
    </>
  );
}

export default withRouter(App);

//unused

/* <>
							<div className='main-layout'>
								<Switch>
									<div className='content'>
										
										<Header />

										<Route path='/register' component={Register} />
										<Route path='/login' component={Login} />
										<Route path='/onboarding' component={Onboarding} />
										<Route exact path='/' component={Login} />
										


									</div>
										<ProtectedRoute path ="/agent" >
										<SecuredRoutes/>
										</ProtectedRoute>		

								</Switch>
							</div>
						</> */

// if(!isLoggedIn){
//  return  <Redirect to={{ to: "/login", state: { from: location } }} />

// }
